"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDataTable = exports.ColumnObjectType = void 0;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * CustomDataTable.tsx
 * Author: Frank Wunderlich
 * Date: 07.02.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_2 = __importStar(require("react"));
const checkbox_1 = require("primereact/checkbox");
const inputtext_1 = require("primereact/inputtext");
const dropdown_1 = require("primereact/dropdown");
const datatable_1 = require("primereact/datatable");
const column_1 = require("primereact/column");
const calendar_1 = require("primereact/calendar");
const button_1 = require("primereact/button");
const react_i18next_1 = require("react-i18next");
const ripple_1 = require("primereact/ripple");
const utils_1 = require("primereact/utils");
const multiselect_1 = require("primereact/multiselect");
require("../style/override.css");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const progressspinner_1 = require("primereact/progressspinner");
const Global_1 = require("../functions/Global");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
const react_router_dom_1 = require("react-router-dom");
const skeleton_1 = require("primereact/skeleton");
const StatusLight_1 = require("./StatusLight");
// @ts-ignore
const CustomConfirmDialog_1 = require("./CustomConfirmDialog");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const menu_1 = require("primereact/menu");
var ColumnObjectType;
(function (ColumnObjectType) {
    ColumnObjectType[ColumnObjectType["Text"] = 0] = "Text";
    ColumnObjectType[ColumnObjectType["Number"] = 1] = "Number";
    ColumnObjectType[ColumnObjectType["Checkbox"] = 2] = "Checkbox";
    ColumnObjectType[ColumnObjectType["Dropdown"] = 3] = "Dropdown";
    ColumnObjectType[ColumnObjectType["Date"] = 4] = "Date";
    ColumnObjectType[ColumnObjectType["Buttons"] = 5] = "Buttons";
    ColumnObjectType[ColumnObjectType["Image"] = 6] = "Image";
    ColumnObjectType[ColumnObjectType["Boolean"] = 7] = "Boolean";
    ColumnObjectType[ColumnObjectType["StatusLights"] = 8] = "StatusLights";
})(ColumnObjectType = exports.ColumnObjectType || (exports.ColumnObjectType = {}));
const CustomDataTable = (props) => {
    const tableRef = (0, react_2.useRef)(null);
    const customButtonRef = (0, react_2.useRef)(null);
    const [width, setWidth] = react_2.default.useState(window.innerWidth);
    const breakpoint = 960;
    const _setWidth = () => {
        setWidth(window.innerWidth);
    };
    const skeletonValues = [];
    const count = props.skeletonCount ? props.skeletonCount : 10;
    for (let i = 0; i < count; i++) {
        // @ts-ignore
        skeletonValues.push([]);
    }
    const params = (0, react_router_dom_1.useParams)();
    const { t } = (0, react_i18next_1.useTranslation)(['common', 'customDataTable']);
    const user_string = localStorage.getItem('user');
    let uuf = false;
    if (user_string) {
        uuf = JSON.parse(user_string).is_saving_userfilters_enabled;
    }
    const [childKey, setChildKey] = (0, react_2.useState)(1);
    const [copy, setCopy] = (0, react_2.useState)([]);
    const [globalFilter, setGlobalFilter] = (0, react_2.useState)('');
    const [columnFilters, setColumnFilters] = (0, react_2.useState)({});
    const [columnDisplayFilters, setColumnDisplayFilters] = (0, react_2.useState)({});
    const [filters, setFilters] = (0, react_2.useState)(props.filters);
    const [pageRows, setPageRows] = (0, react_2.useState)(10);
    const [first, setFirst] = (0, react_2.useState)(0);
    const [filterTemp, setFilterTemp] = (0, react_2.useState)(undefined);
    const [expandedRows, setExpandedRows] = (0, react_2.useState)(null);
    const [startScrollToFirstExpandedRow, setStartScrollToFirstExpandedRow] = (0, react_2.useState)(false);
    const [startScrollToFirstSelectedRow, setStartScrollToFirstSelectedRow] = (0, react_2.useState)(false);
    const [scrollToFirstRowTriggered, setScrollToFirstRowTriggered] = (0, react_2.useState)(false);
    const [useUserFilters, setUseUserFilters] = (0, react_2.useState)(uuf);
    const [filterVals, setFilterVals] = (0, react_2.useState)({});
    const [dates, setDates] = (0, react_2.useState)(null);
    const [showSkeleton, setShowSkeleton] = (0, react_2.useState)(true);
    // console.log('props', props);
    // const [makeCopy, setMakeCopy] = useState(true);
    const [isMobile, setIsMobile] = (0, react_2.useState)(false);
    const [sortField, setSortField] = (0, react_2.useState)(undefined);
    const [sortOrder, setSortOrder] = (0, react_2.useState)(undefined);
    const [sortedValues, setSortedValues] = (0, react_2.useState)([]);
    const [scrollEvent, setScrollEvent] = (0, react_2.useState)(undefined);
    const buttonIconWidth = 45;
    const customButtonWidth = 60;
    const getCustomButtonWidth = () => {
        let result = 0;
        if (props.customButtons) {
            const buttonsCount = props.customButtons.filter(item => {
                return item.permitted;
            }).length;
            result = buttonsCount * customButtonWidth;
            if (props.maxButtonsShown && props.maxButtonsShown < buttonsCount) {
                result = props.maxButtonsShown * customButtonWidth;
            }
        }
        return result;
    };
    const buttonColumnWidth = (props.ableToUpdate ? buttonIconWidth : 0)
        + (props.ableToDelete && (typeof props.selectionMode === 'undefined' || props.selectionMode === 'single') ? buttonIconWidth : 0)
        + getCustomButtonWidth();
    const showPaginator = () => {
        return typeof props.paginator === 'boolean' ? props.paginator : props.value ? props.value.length > 100 : false;
    };
    (0, react_2.useEffect)(() => {
        setIsMobile(breakpoint >= width);
    }, [width]);
    (0, react_2.useEffect)(() => {
        setChildKey(prev => prev + 1);
    }, [isMobile]);
    (0, react_2.useEffect)(() => {
        window.addEventListener('resize', _setWidth);
        document.removeEventListener('scroll', onScroll, true);
        setScrollEvent(document.addEventListener('scroll', onScroll, true));
        return () => {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
            if (filterDelayTimeout) {
                clearTimeout(filterDelayTimeout);
            }
            window.removeEventListener('resize', _setWidth);
            document.removeEventListener('scroll', onScroll, true);
            setScrollEvent(undefined);
            tableRef.current = null;
        };
    }, []);
    (0, react_2.useEffect)(() => {
        if (tableRef.current) {
            tableRef.current.reset();
        }
    }, [filters]);
    (0, react_2.useEffect)(() => {
        setExpandedRows(props.expandedRows);
    }, [props.expandedRows]);
    (0, react_2.useEffect)(() => {
        if (sortedValues && sortedValues.length > 0) {
            const pRows = localStorage.getItem('pageRows_' + props.id);
            if (pRows) {
                setPageRows(parseInt(pRows));
                if (props.scrollToFirstExpanded && props.expandedRows && props.expandedRows.length && !scrollToFirstRowTriggered) {
                    const firstExpandedRows = props.expandedRows[0];
                    _setFirst(firstExpandedRows, 'expanded');
                }
            }
        }
    }, [props.scrollToFirstExpanded, sortedValues]);
    (0, react_2.useEffect)(() => {
        const pRows = localStorage.getItem('pageRows_' + props.id);
        if (pRows) {
            setPageRows(parseInt(pRows));
            if (props.scrollToFirstSelection && props.selection && !scrollToFirstRowTriggered) {
                const firstSelectedRow = props.selection[0];
                _setFirst(firstSelectedRow, 'selected');
            }
        }
    }, [props.scrollToFirstSelection, sortedValues]);
    (0, react_2.useEffect)(() => {
        if (props.dataloaded === true) {
            setShowSkeleton(false);
        }
    }, [props.dataloaded]);
    const _setFirst = (rows, type) => {
        let index = -1;
        const items = sortedValues;
        for (let i = 0; i < items.length; i++) {
            if (items[i] === rows) {
                index = i;
                break;
            }
        }
        if (index >= 0) {
            let firstValue = 0;
            while (firstValue < (index - pageRows + 1)) {
                firstValue += pageRows;
            }
            setFirst(firstValue);
            // setFirst(firstValue > 0 ? firstValue - (sortOrder < 0 ? pageRows : 0) : firstValue);
            switch (type) {
                case 'expanded':
                    setStartScrollToFirstExpandedRow(true);
                    break;
                case 'selected':
                    setStartScrollToFirstSelectedRow(true);
                    break;
            }
        }
    };
    const onScroll = (e) => {
        if (tableRef.current) {
            const element = tableRef.current.getElement();
            if (element.classList.contains('p-datatable')) {
                const all = element.querySelectorAll('table tbody tr');
                const expanded = element.querySelectorAll('table tbody tr+tr.p-datatable-row-expansion');
                for (let i = 0; i < all.length; i++) {
                    all[i].classList.remove('fixed-row');
                    all[i].style.top = undefined;
                }
                for (let i = 0; i < expanded.length; i++) {
                    expanded[i].style.marginTop = 'inherit';
                }
                const tableWrapper = element.querySelector('.p-datatable-wrapper');
                const thead = tableWrapper.querySelector('table thead');
                const scrollTop = tableWrapper.scrollTop;
                for (let i = 0; i < expanded.length; i++) {
                    const exp = expanded[i];
                    const prev = exp.previousElementSibling;
                    const pos = prev.offsetTop - thead.clientHeight;
                    const addOffset = 12;
                    if (prev.offsetTop - prev.clientHeight < scrollTop + addOffset && exp.offsetTop + exp.clientHeight > scrollTop) {
                        let posPrev = thead.clientHeight + scrollTop;
                        const posExp = prev.clientHeight;
                        if (scrollTop > (exp.offsetTop + exp.clientHeight) - (prev.clientHeight + thead.clientHeight)) {
                            // console.log(scrollTop, (exp.offsetTop + exp.clientHeight) - (prev.clientHeight + thead.clientHeight) - scrollTop);
                            const offset = (exp.offsetTop + exp.clientHeight) - (prev.clientHeight + thead.clientHeight) - scrollTop;
                            posPrev += offset;
                            // posExp += offset;
                        }
                        prev.classList.add('fixed-row');
                        prev.style.top = posPrev + 'px';
                        exp.style.marginTop = posExp + 'px';
                    }
                }
            }
        }
    };
    let timeoutIdExpand = null;
    let timeoutIdSelection = null;
    (0, react_2.useEffect)(() => {
        if (tableRef.current) {
            if (!scrollToFirstRowTriggered && !showSkeleton) {
                if (props.scrollToFirstExpanded === true && expandedRows && expandedRows.length && startScrollToFirstExpandedRow) {
                    if (timeoutIdExpand) {
                        clearTimeout(timeoutIdExpand);
                    }
                    timeoutIdExpand = setTimeout(() => {
                        const exp = tableRef.current.getElement().getElementsByClassName('p-datatable-row-expansion');
                        if (exp.length > 0 && exp[0]) {
                            const scrollFunc = () => {
                                exp[0].scrollIntoView(false);
                            };
                            if (props.scrollToFirstExpandedTimeout) {
                                timeoutIdSelection = setTimeout(scrollFunc, props.scrollToFirstExpandedTimeout);
                            }
                            else {
                                scrollFunc();
                            }
                        }
                        setScrollToFirstRowTriggered(true);
                    }, 1500);
                }
                if (props.scrollToFirstSelection === true && props.selection && startScrollToFirstSelectedRow) {
                    if (timeoutIdSelection) {
                        clearTimeout(timeoutIdSelection);
                    }
                    timeoutIdSelection = setTimeout(() => {
                        const exp = tableRef.current.getElement().getElementsByClassName('p-datatable-row-expansion');
                        if (exp.length > 0 && exp[0]) {
                            const scrollFunc = () => {
                                exp[0].scrollIntoView(false);
                            };
                            scrollFunc();
                        }
                        setScrollToFirstRowTriggered(true);
                    }, 1500);
                }
            }
        }
        return () => {
            if (timeoutIdExpand) {
                clearTimeout(timeoutIdExpand);
            }
            if (timeoutIdSelection) {
                clearTimeout(timeoutIdSelection);
            }
        };
    }, [props.scrollToFirstExpanded, props.scrollToFirstSelection, expandedRows, first, startScrollToFirstExpandedRow, startScrollToFirstSelectedRow]);
    const [selectedColumns, setSelectedColumns] = (0, react_2.useState)([]);
    (0, react_2.useEffect)(() => {
        updateColumns();
    }, [props.columns]);
    const updateColumns = () => {
        try {
            const settings = (0, Global_1.getUserFromLocalStorage)().settings;
            const displaySettings = settings['display_' + props.id];
            let tmp;
            if (displaySettings && displaySettings.length > 0) {
                tmp = props.columns.filter(col => displaySettings.indexOf(col.field) >= 0);
            }
            else {
                tmp = props.columns.filter(col => col.display === true || col.display !== false);
            }
            const columnOrder = settings['columnorder_' + props.id];
            if (columnOrder && columnOrder.length > 0) {
                tmp.sort((a, b) => {
                    return columnOrder.indexOf(a.field) > columnOrder.indexOf(b.field) ? 1 : -1;
                });
            }
            const sort = settings['sort_' + props.id];
            if (sort) {
                setSortField(sort.sortField);
                setSortOrder(sort.sortOrder);
            }
            setSelectedColumns(tmp);
        }
        catch (error) {
            // console.log('CustomDataTable Error', error);
        }
    };
    (0, react_2.useEffect)(() => {
        if (props.value && sortField) {
            const valueToSort = sortedValues && sortedValues.length ? [...sortedValues] : [...props.value];
            setSortedValues(valueToSort.sort((a, b) => {
                const aValue = a[sortField];
                const bValue = b[sortField];
                // Behandle null oder undefined Werte
                if (aValue == null && bValue == null) {
                    return 0;
                }
                if (aValue == null) {
                    return sortOrder > 0 ? -1 : 1;
                }
                if (bValue == null) {
                    return sortOrder > 0 ? 1 : -1;
                }
                // Wenn beide Werte vorhanden sind, vergleiche sie
                if (sortOrder > 0) {
                    return aValue.toString().localeCompare(bValue.toString());
                }
                else {
                    return bValue.toString().localeCompare(aValue.toString());
                }
            }));
        }
    }, [sortOrder, sortField, JSON.stringify(props.value)]);
    const onColumnToggle = (event) => {
        const selectedColumns = event.value;
        const orderedSelectedColumns = props.columns.filter(col => selectedColumns.some((sCol) => sCol.field === col.field));
        //  console.log('orderedSelectedColumns', orderedSelectedColumns);
        setSelectedColumns(orderedSelectedColumns);
        clearTimeout(filterDelayTimeout);
        filterDelayTimeout = setTimeout(() => {
            (0, Global_1.setUserSettings)('display_' + props.id, orderedSelectedColumns.map(item => item.field), props.keycloakfetch, props.settings, undefined, true);
            (0, Global_1.setUserSettings)('columnorder_' + props.id, orderedSelectedColumns.map(item => item.field), props.keycloakfetch, props.settings);
        }, 500);
    };
    const convertToCSV = (data) => {
        const rows = [];
        const csvSeparator = ';';
        // 1. Add header row
        let header = '';
        props.columns && selectedColumns.length > 0 && selectedColumns.map((column) => {
            header += column.header + csvSeparator;
        });
        // Füge die Header-Zeile hinzu. Entferne aber das letzte Komma, da es überflüssig ist
        // @ts-ignore
        rows.push(header.slice(0, -1));
        // 2. Add data rows
        data.forEach((row) => {
            // Filtere nur die Spalten, die im Objekt vorhanden sind
            const filteredColumns = selectedColumns.filter(column => Object.keys(row).includes(column.field));
            // Extrahiere die Werte in der Reihenfolge der gefilterten Spalten
            const values = filteredColumns.map(column => row[column.field]);
            // Erstelle die Semikolon-separierte Zeichenkette
            // @ts-ignore
            rows.push(values.join(csvSeparator));
        });
        return rows.join('\n');
    };
    const exportCSV = () => {
        // eslint-disable-next-line new-cap
        (0, CustomConfirmDialog_1.CustomConfirmDialog)({
            message: t('customdatatable_exportAsCsv'),
            header: t('confirmation'),
            translation: t,
            onConfirm: () => {
                const data = convertToCSV(props.value);
                // Create a Byte Order Mark, so that excel will use UTF-8 instead of ANSI for encoding
                // https://stackoverflow.com/questions/42462764/javascript-export-csv-encoding-utf-8-issue
                const universalBOM = '\uFEFF';
                const blob = new Blob([universalBOM + data], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'data.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    };
    const header = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !props.hideSearch && (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "table-header grid" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col p-0" }, { children: props.header ? props.header : (0, jsx_runtime_1.jsx)("h4", Object.assign({ className: "m-0 white-space-nowrap" }, { children: props.headerTitle })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grid grid-nogutter flex" }, { children: [props.displayColumnFilter === true &&
                            (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col mb-2 md:mb-0 md:mr-3' }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [(0, jsx_runtime_1.jsx)(multiselect_1.MultiSelect, { value: selectedColumns, options: props.columns, optionLabel: "header", onChange: onColumnToggle, 
                                            // style={{width: '20em'}}
                                            placeholder: t('cstmDataTbl_VisibleColumns'), fixedPlaceholder: true }), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-undo", className: "p-button-secondary", onClick: () => {
                                                (0, CustomConfirmDialog_1.CustomConfirmDialog)({
                                                    header: t('dialogs_resetColumnsHeader'),
                                                    message: t('dialogs_resetColumnsMessage'),
                                                    translation: t,
                                                    onConfirm: () => {
                                                        (0, Global_1.setUserSettings)('display_' + props.id, undefined, props.keycloakfetch, props.settings);
                                                        (0, Global_1.setUserSettings)('columnorder_' + props.id, undefined, props.keycloakfetch, props.settings);
                                                        window.location.reload();
                                                    }
                                                });
                                            } })] })) })), (props.hideGlobalFilter === undefined || props.hideGlobalFilter === false) &&
                            (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "search-input col-12 md:col " }, { children: [props.timerangefield &&
                                        (0, jsx_runtime_1.jsx)(calendar_1.Calendar, { value: dates, className: "mr-2", dateFormat: "dd.mm.yy", onChange: (e) => {
                                                setDates(e.value);
                                                props.onTimeRangeSelect && props.onTimeRangeSelect(e.value);
                                            }, selectionMode: "range", readOnlyInput: true, placeholder: t('conditionMon_alarm_range') }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "p-input-icon-left w-full md:w-auto" }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-search" }), (0, jsx_runtime_1.jsx)(inputtext_1.InputText, { className: 'w-full md:-wauto', type: "search", onInput: (e) => {
                                                    setGlobalFilter(e.target.value || []);
                                                }, placeholder: t('cstmDataTbl_placeholder') })] }))] })), props.showExportCSV === true &&
                            (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "search-input ml-3 my-auto" }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, { className: 'p-button-outlined', icon: 'pi pi-file', onClick: exportCSV, tooltip: t('tooltip_exportAsCSV'), tooltipOptions: { position: 'left' } }) }))] })), props.showLoading &&
                    (0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            textAlign: 'center',
                            zIndex: '3000'
                        } }, { children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { style: { width: '50px', height: '50px', margin: 'auto', zIndex: '4000' }, animationDuration: ".5s" }) }))] })) }));
    const isChanged = (rowData, key) => {
        // console.log(rowData);
        // return rowData.ChangedByUser || false;
        return rowData.ChangedByUser && rowData.ChangedByUser.indexOf(key) >= 0;
        // let changed = false;
        // if (copy.length) {
        //     let copyItems = copy.filter((x: any) => {
        //         return x.Id === rowData.Id
        //     });
        //
        //     if (copyItems.length) {
        //         changed = copyItems[0][key] !== rowData[key];
        //     }
        // }
        // return changed;
    };
    const textColumn = (rowData, key, onClick) => {
        // console.log('rowData: ',rowData);
        // console.log('key: ', key);
        // console.log(typeof rowData[key]);
        let value = rowData[key];
        if (onClick !== undefined) {
            value = ((0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: (e) => {
                    e.stopPropagation();
                    onClick(rowData);
                } }, { children: (0, jsx_runtime_1.jsx)("u", { children: value }) })));
        }
        if (key === 'is_enabled') {
            const dynamicProps = {};
            if (rowData['is_enabled'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_enabled'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_enabled'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'is_visible') {
            const dynamicProps = {};
            if (rowData['is_visible'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_visible'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_visible'] ? free_solid_svg_icons_1.faEye : free_solid_svg_icons_1.faEyeSlash, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'is_active') {
            const dynamicProps = {};
            if (rowData['is_active'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_active'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_active'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'is_logical') {
            const dynamicProps = {};
            if (rowData['is_logical'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_logical'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_logical'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2 text-center" }, dynamicProps)) })));
        }
        else if (key === 'flag') {
            const dynamicProps = {};
            if (rowData['flag'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['flag'] === null ? free_solid_svg_icons_1.faSlash : rowData['flag'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'mobile') {
            const dynamicProps = {};
            if (rowData['mobile'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['mobile'] === null ? free_solid_svg_icons_1.faSlash : rowData['mobile'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'is_automatic') {
            const dynamicProps = {};
            if (rowData['is_automatic'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_automatic'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_automatic'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'is_rotational_speed_dependent') {
            const dynamicProps = {};
            if (rowData['is_rotational_speed_dependent'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['is_rotational_speed_dependent'] === null ? free_solid_svg_icons_1.faSlash : rowData['is_rotational_speed_dependent'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'save_in_nextcloud') {
            const dynamicProps = {};
            if (rowData['save_in_nextcloud'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['save_in_nextcloud'] === null ? free_solid_svg_icons_1.faSlash : rowData['save_in_nextcloud'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else if (key === 'send_as_pdf') {
            const dynamicProps = {};
            if (rowData['send_as_pdf'])
                dynamicProps['style'] = { color: 'green' };
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: rowData['send_as_pdf'] === null ? free_solid_svg_icons_1.faSlash : rowData['send_as_pdf'] ? free_regular_svg_icons_1.faCircleCheck : free_regular_svg_icons_1.faCircleXmark, className: "m-2" }, dynamicProps)) })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", { children: value }));
        }
    };
    const checkboxColumn = (rowData, key) => {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: isChanged(rowData, key) ? 'changed' : '' }), (0, jsx_runtime_1.jsx)(checkbox_1.Checkbox, { className: (rowData.DeletedByUser ? 'deleted' : '') + (rowData.CreatedByUser ? ' created' : ''), checked: rowData[key], disabled: true })] }));
    };
    const dateColumn = (0, react_2.useCallback)((rowData, key, dateFormat = 'DD.MM.YYYY HH:mmZ') => {
        const timezone = (0, Global_1.getUserFromLocalStorage)().timezone;
        let value = '';
        if (rowData[key]) {
            value = (0, moment_timezone_1.default)(rowData[key]).tz(timezone).format(dateFormat);
        }
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: isChanged(rowData, key) ? 'changed' : '' }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (rowData.DeletedByUser ? 'deleted' : '') + (rowData.CreatedByUser ? ' created' : '') }, { children: value !== 'Invalid date' ? value : '-' }))] }));
    }, []);
    const buttonTemplate = (rowData, options) => {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "grid grid-nogutter" }, { children: options.map((item, index) => {
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (index < options.length - 1 ? 'mr-2' : '') }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ type: 'button', className: "py-1 p-button-sm p-button-outlined", onClick: () => item.onClick(rowData.Id) }, { children: item.html })) })));
            }) })));
    };
    const buttonColumn = (selection, options) => {
        const currentSelection = Object.assign({}, selection);
        if (!customButtonRef.current) {
            customButtonRef.current = [];
        }
        // console.log(selection);
        const remove = (currentSelection) => {
            if (props.onRemoveClick)
                props.onRemoveClick(currentSelection);
        };
        const edit = (currentSelection) => {
            if (props.onEditClick)
                props.onEditClick(currentSelection);
        };
        let canBeDeleted = true;
        if (currentSelection.users) {
            if (currentSelection.users.length > 0) {
                canBeDeleted = false;
            }
        }
        // console.log(typeof props.selectionMode === 'undefined')
        // console.log(props.selectionMode === 'single')
        // console.log((typeof props.selectionMode === 'undefined' || props.selectionMode === 'single'))
        // console.log(props.ableToDelete && (typeof props.selectionMode === 'undefined' || props.selectionMode === 'single'))
        let customButtons = [];
        const appendButtons = [];
        if (props.ableToUpdate) {
            appendButtons.push((0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ type: 'button', className: "p-button mx-1 p-button-text overflow-visible", style: { minWidth: '20px' }, tooltip: props.buttonToolTipEdit ? props.buttonToolTipEdit : t('edit'), tooltipOptions: { position: 'top' }, "data-label": t('edit'), onClick: () => {
                    edit(currentSelection);
                } }, { children: (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-pencil' }) })));
        }
        if (props.ableToDelete) {
            appendButtons.push((0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ type: 'button', className: "p-button-danger p-button-text mx-1 overflow-visible", style: { minWidth: '20px' }, disabled: !canBeDeleted, tooltip: props.buttonToolTipDelete ? props.buttonToolTipDelete : t('delete'), tooltipOptions: { position: 'top' }, "data-label": t('delete'), onClick: () => {
                    remove(currentSelection);
                } }, { children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-trash" }) })));
        }
        if (props.customButtons) {
            customButtons = props.customButtons.map(item => {
                if (item.permitted) {
                    // Setze icon initial mit dem nullten Element (Standardfall)
                    let icon = item.icons[0].icon;
                    // Bei mehreren, setze icon je nach Wert
                    for (const iconObj of item.icons) {
                        const value = currentSelection[iconObj.key];
                        if (value === iconObj.value) {
                            icon = iconObj.icon;
                            break;
                        }
                    }
                    const className = item.className ? item.className + ' p-button mx-1 p-button-text' : 'p-button mx-1 p-button-text';
                    return ((0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ "data-label": item.label, type: 'button', className: className, style: { minWidth: '20px' }, tooltip: item.tooltip, tooltipOptions: item.tooltipOptions, onClick: (e) => {
                            if (e.originalEvent) {
                                e.originalEvent.preventDefault();
                            }
                            else {
                                e.preventDefault();
                            }
                            item.onClick(currentSelection);
                        } }, item.options, { children: icon })));
                }
            });
        }
        if (props.prependCustomButtons) {
            appendButtons.unshift(...customButtons);
        }
        else {
            appendButtons.push(...customButtons);
        }
        if (props.maxButtonsShown) {
            if (props.maxButtonsShown < appendButtons.length) {
                const items = [];
                for (let i = appendButtons.length - 1; i > -1; i--) {
                    const button = Object.assign({}, appendButtons[i]);
                    if (button) {
                        if (i >= props.maxButtonsShown) {
                            appendButtons.splice(i, 1);
                            items.unshift({
                                label: button.props['data-label'],
                                icon: button.props.children,
                                command: button.props.onClick
                            });
                        }
                    }
                }
                if (items.length) {
                    appendButtons.push((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(menu_1.Menu, { className: 'icon-margin-right', model: items, popup: true, ref: (ref) => {
                                    customButtonRef.current[options.rowIndex] = ref;
                                }, id: "popup_menu_right", popupAlignment: "right" }), (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ className: "p-button-text ml-2", onClick: (event) => customButtonRef.current[options.rowIndex].toggle(event), "aria-controls": "popup_menu_right", "aria-haspopup": true }, { children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-ellipsis-v" }) }))] }));
                }
            }
        }
        return appendButtons;
    };
    const imageTemplate = (rowData, key) => {
        return (0, jsx_runtime_1.jsx)("img", { src: rowData[key] });
    };
    const skeletonBodyTemplate = () => {
        return (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { height: "2.3rem" });
    };
    const onPage = (e) => {
        const rows = parseInt(e.rows);
        localStorage.setItem('pageRows_' + props.id, e.rows);
        setPageRows(rows);
        setFirst(parseInt(e.first));
        return rows;
    };
    const template1 = {
        layout: 'CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown',
        'PrevPageLink': (options) => {
            return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: options.className, onClick: options.onClick, disabled: options.disabled }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-angle-left" }) })), (0, jsx_runtime_1.jsx)(ripple_1.Ripple, {})] })));
        },
        'NextPageLink': (options) => {
            return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: options.className, onClick: options.onClick, disabled: options.disabled }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-angle-right" }) })), (0, jsx_runtime_1.jsx)(ripple_1.Ripple, {})] })));
        },
        'PageLinks': (options) => {
            // console.log(options)
            // if ((options.view.startPage === options.page && options.view.startPage !== 0) || (options.view.endPage === options.page && options.page + 1 !== options.totalPages)) {
            //     const className = classNames(options.className, {'p-disabled': true});
            //
            //     return <span className={className} style={{userSelect: 'none'}}>...</span>;
            // }
            if (options.page != options.currentPage) {
                return (0, jsx_runtime_1.jsx)("div", {});
            }
            return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: options.className, onClick: options.onClick }, { children: [options.page + 1 + '/' + (options.totalPages), (0, jsx_runtime_1.jsx)(ripple_1.Ripple, {})] })));
        },
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 3, value: 3 },
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 },
                // {label: t('customDataTable:paginator.all'), value: options.totalRecords}
            ];
            if (!props.paginatorHideAll) {
                dropdownOptions.push({ label: t('cstmDataTbl_paginatorAll'), value: options.totalRecords });
            }
            return (0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { value: options.value, options: dropdownOptions, onChange: options.onChange });
        },
    };
    const booleanTemplate = (rowData, field) => {
        return ((0, jsx_runtime_1.jsx)("i", { className: (0, utils_1.classNames)('pi', {
                'true-icon pi-check-circle': rowData[field],
                'false-icon pi-minus': !rowData[field]
            }) }));
    };
    const statusLightsTemplate = (rowData, field, options) => {
        return getStatusLights(options.rowIndex, rowData[field], rowData['active_id']);
    };
    const statusFilterTemplate = (options) => {
        const statuses = [0, 1, 2, 3];
        return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { value: options.value, options: statuses, onChange: (e) => options.filterApplyCallback(e.value), itemTemplate: (e) => {
                return getStatusLights(0, e, 0);
            }, valueTemplate: (e) => {
                return getStatusLights(0, e, 0);
            }, className: "p-column-filter" }));
    };
    const getStatusLights = (index, field, active_id) => {
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(StatusLight_1.StatusLight, { id: 'statuslight-' + index, value: field, info: 'Testinfo für Row ' + index, light: false, horizontal: true, 
                // caution={false}
                inactive: active_id != null ? active_id > 0 : false, scale: isMobile ? 0.8 : undefined }) }));
    };
    const filterDropdownTemplate = (options, values, field) => {
        // console.log("options", options);
        // console.log("values", values);
        // console.log('colfilter', columnFilters);
        if (values) {
            for (let i = 0; i < values.length; i++) {
                const item = values[i];
                if (item.value === undefined) {
                    item.value = item.id;
                }
            }
        }
        // console.log("values", values);
        return ((0, jsx_runtime_1.jsx)(multiselect_1.MultiSelect, { value: options.value, options: values, itemTemplate: (option) => {
                return ((0, jsx_runtime_1.jsx)("div", { children: option.name }));
            }, 
            // selectedItemsLabel={'{0} ' + t('customDataTable:filter.items_selected')}
            // maxSelectedLabels={1}
            onChange: (e) => {
                //  console.log('event', e);
                if (props.filterOptionSelected) {
                    const optionKey = options['field'];
                    let filterArr = {};
                    filterArr = Object.assign(Object.assign({}, filterVals), { [optionKey]: e['value'] });
                    setFilterVals(Object.assign(Object.assign({}, filterVals), { [optionKey]: e['value'] }));
                    props.selectedFilters && props.selectedFilters(filterArr);
                    options['field'] === props.filterOptionsField && props.filterOptionSelected(e['value']);
                }
                setColumnFilters((prevState) => (Object.assign(Object.assign({}, prevState), { [options.field]: e.value })));
                return options.filterApplyCallback(e.value);
                // options.filterApplyCallback(e.value);
                // options.filterCallback(e.value);
            }, optionLabel: field ? field : 'name', placeholder: t('cstmDataTbl_FilterAny'), className: "p-column-filter" }));
    };
    const allowExpansion = (rowData) => {
        return rowData.expandableElement !== undefined;
    };
    const rowExpansionTemplate = (rowData) => {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "relative", style: { 'zIndex': '0' } }, { children: rowData.expandableElement })));
    };
    const textEditor = (options) => {
        return getEditor(options, 'text');
    };
    const numberEditor = (options) => {
        return getEditor(options, 'number');
    };
    const dateEditor = (options) => {
        return getEditor(options, 'datetime-local');
    };
    const getEditor = (options, type) => {
        return ((0, jsx_runtime_1.jsx)(inputtext_1.InputText, { className: (0, utils_1.classNames)(options.column.props.editCellClassName), style: options.column.props.editCellStyle, type: type, value: options.value, onChange: (e) => options.editorCallback(e.target.value) }));
    };
    const dropdownEditor = (options, items) => {
        return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { className: (0, utils_1.classNames)('w-full', options.column.props.editCellClassName), style: options.column.props.editCellStyle, value: options.value ? options.value.toString() : null, options: items.map((i) => {
                return { value: i.id, label: i.name };
            }), onChange: (e) => options.column.props.editCell(e.target.value) }));
    };
    const settings = (0, Global_1.getUserFromLocalStorage)().settings;
    (0, react_2.useEffect)(() => {
        if (useUserFilters) {
            let filterSettings = {};
            if (params && params.projectId) {
                if (settings[params.projectId]) {
                    filterSettings = settings[params.projectId]['filters_' + props.id];
                }
            }
            if (filterSettings && props.filters) {
                let tempFilters = Object.assign({}, props.filters);
                for (let i = 0; i < Object.keys(filterSettings).length; i++) {
                    const key = Object.keys(filterSettings)[i];
                    tempFilters[key] = filterSettings[key];
                }
                setFilters(tempFilters);
            }
        }
    }, [useUserFilters]);
    const spreadProps = Object.assign({}, props);
    // // @ts-ignore
    // delete spreadProps.editable;
    // delete spreadProps.ableToDelete;
    // delete spreadProps.ableToUpdate;
    // delete spreadProps.headerTitle;
    // delete spreadProps.onEditClick;
    // delete spreadProps.onRemoveClick;
    // delete spreadProps.hideGlobalFilter;
    // // @ts-ignore
    // delete spreadProps.sortable;
    // delete spreadProps.expandable;
    // delete spreadProps.filters;
    // delete spreadProps.dataloaded;
    // delete spreadProps.skeletonCount;
    // delete spreadProps.displayColumnFilter;
    // delete spreadProps.paginatorHideAll;
    // delete spreadProps.customButtons;
    // delete spreadProps.scrollToFirstExpanded;
    // delete spreadProps.scrollToFirstExpandedTimeout;
    // delete spreadProps.prependCustomButtons;
    let filterDelayTimeout;
    let scrollTimeout;
    const onSort = (e) => {
        console.log('sort', e);
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
        (0, Global_1.setUserSettings)('sort_' + props.id, {
            sortField: e.sortField,
            sortOrder: e.sortOrder
        }, props.keycloakfetch, props.settings);
    };
    const onValueChange = (0, react_2.useCallback)((values) => {
        if (props.onFilteredValue) {
            props.onFilteredValue(values);
        }
        setSortedValues(values);
    }, [props.onFilteredValue]);
    const onColReorder = (0, react_2.useCallback)((e) => {
        //  console.log('reorder', e);
        const columnOrder = e.columns.map((x) => x.props.field);
        (0, Global_1.setUserSettings)('columnorder_' + props.id, columnOrder, props.keycloakfetch, props.settings);
    }, [props.onFilteredValue]);
    const rowClassName = (0, react_2.useCallback)((data, options) => {
        if (props.rowClass && props.rowClass.length > 0) {
            for (let i = 0; i < props.rowClass.length; i++) {
                const rc = props.rowClass[i];
                if (data[rc.key] === rc.value) {
                    return rc.class;
                }
            }
        }
        return '';
    }, [props.rowClass]);
    const onRowExpand = (0, react_2.useCallback)((e) => {
        if (props.onRowExpand) {
            props.onRowExpand(e);
        }
        scrollTimeout = setTimeout(onScroll, 100);
    }, [props.onRowExpand]);
    const onRowToggle = (0, react_2.useCallback)((e) => {
        setExpandedRows(e.data);
        if (props.onRowToggle)
            props.onRowToggle(e);
    }, [props.onRowToggle]);
    const onRowCollapse = (0, react_2.useCallback)((e) => {
        if (props.onRowCollapse) {
            props.onRowCollapse(e);
        }
        scrollTimeout = setTimeout(onScroll, 100);
    }, [props.onRowCollapse]);
    const onFilter = (0, react_2.useCallback)((e) => {
        setFilters(e.filters);
        if (useUserFilters) {
            let save = true;
            if (filterTemp) {
                const tmp = filterTemp;
                delete e.filters.global;
                delete tmp.global;
                if (JSON.stringify(e.filters) === JSON.stringify(tmp)) {
                    save = false;
                }
            }
            if (save) {
                clearTimeout(filterDelayTimeout);
                filterDelayTimeout = setTimeout(() => {
                    if (params && params.projectId) {
                        (0, Global_1.setUserSettings)('filters_' + props.id, e.filters, props.keycloakfetch, props.settings, params.projectId);
                    }
                }, 1500);
            }
            setFilterTemp(e.filters);
        }
        if (props.onFilterChanged) {
            props.onFilterChanged(e.filters);
        }
    }, [props.onFilterChanged]);
    const handleCheckboxSort = (event) => {
        if (!sortedValues || !props.selection)
            return;
        const sortOrder = event.order; // 1 für aufsteigend, -1 für absteigend
        const sortedData = [...sortedValues].sort((a, b) => {
            const aSelected = props.selection.includes(a);
            const bSelected = props.selection.includes(b);
            if (aSelected && !bSelected) {
                return sortOrder === 1 ? -1 : 1; // Ausgewählte oben (aufsteigend) oder unten (absteigend)
            }
            if (!aSelected && bSelected) {
                return sortOrder === 1 ? 1 : -1;
            }
            return 0; // Gleiche Priorität
        });
        return sortedData;
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, react_1.createElement)(datatable_1.DataTable, Object.assign({}, spreadProps, { key: childKey, ref: tableRef, value: showSkeleton ? skeletonValues : props.value, onValueChange: onValueChange, reorderableColumns: true, onColReorder: onColReorder, sortField: sortField, sortOrder: sortOrder, onSort: onSort, rowClassName: rowClassName, scrollHeight: props.scrollHeight || 'flex', style: props.style || { 'tableLayout': 'fixed' }, columnResizeMode: "fit", resizableColumns: !isMobile, filters: filters, showGridlines: true, className: (0, utils_1.classNames)('pt-2', (props.className ? ' ' + props.className : ''), isMobile ? 'stack' : ''), globalFilter: globalFilter, header: header, scrollable: true, selectionMode: (typeof props.selectionMode === 'undefined') ? 'single' : props.selectionMode, 
            // onSelectionChange={(e: any) => {
            //     console.log(e);
            //     if (props.onSelectionChange) {
            //         props.onSelectionChange(e);
            //     }
            // }}
            paginator: showPaginator(), onPage: onPage, first: first ? first : 0, rows: pageRows ? pageRows : 10, rowsPerPageOptions: [10, 20, 50, 100], responsiveLayout: "stack", breakpoint: breakpoint + 'px', paginatorTemplate: template1, currentPageReportTemplate: t('cstmDataTbl_paginatorShowing') + ' {first} ' + t('cstmDataTbl_paginatorTo') + ' {last} ' + t('cstmDataTbl_paginatorOf') + ' {totalRecords}', emptyMessage: t('cstmDataTbl_noentry'), filterDisplay: "menu", onFilter: onFilter, expandedRows: expandedRows, onRowToggle: onRowToggle, onRowExpand: onRowExpand, onRowCollapse: onRowCollapse, rowExpansionTemplate: rowExpansionTemplate }),
            props.columns && selectedColumns.length > 0 && (props.editable || (props.customButtons && props.customButtons.find((item) => {
                return item.permitted;
            }))) &&
                (0, jsx_runtime_1.jsx)(column_1.Column, { body: showSkeleton ? skeletonBodyTemplate : buttonColumn, columnKey: 'buttons', className: 'no-hover justify-content-end', field: "buttons", style: isMobile ? undefined : { width: buttonColumnWidth + 'px' }, 
                    // frozen={true}
                    alignFrozen: "left", reorderable: false, resizeable: false }),
            props.columns && selectedColumns.length > 0 && (props.selectionMode && props.selectionMode === 'checkbox') &&
                // In diesem Modus kann man eine Zeile nur selektieren, wenn die Checkbox angeklickt wurde. Dann muss die
                // Spalte aber den selectionMode 'multiple' besitzen und die DataTable den selectionMode 'checkbox'
                (0, jsx_runtime_1.jsx)(column_1.Column, { body: showSkeleton ? skeletonBodyTemplate : undefined, columnKey: 'checkbox', field: 'checkbox', className: "selection-column no-hover", selectionMode: 'multiple', reorderable: false, resizeable: false, sortable: props.sortable && props.checkboxSort, sortFunction: handleCheckboxSort }),
            props.columns && selectedColumns.length > 0 && props.expandable && !isMobile &&
                (0, jsx_runtime_1.jsx)(column_1.Column, { body: showSkeleton ? skeletonBodyTemplate : undefined, columnKey: 'expander', className: "expander-column no-hover", expander: allowExpansion, style: { width: '30px' }, reorderable: false, resizeable: false }),
            props.columns && selectedColumns.length > 0 && props.columns && selectedColumns.map((item, index) => {
                item = Object.assign({}, item);
                if (isMobile) {
                    delete item.style;
                }
                const filterTemplate = {
                    showApplyButton: false,
                    showClearButton: item.filterDropdownValues ? false : true,
                    showAddButton: false,
                    showFilterMatchModes: false,
                    showFilterMenuOptions: true,
                    showFilterOperator: false
                };
                // Funktioniert leider nicht, scheinbar gibt es keine Möglichkeit die Columns resizeable zu machen und dann initial eine individuelle Breite zu setzen...
                // minWidth würde die Breite setzen, aber dann hat man keine Möglichkeit die Column wieder kleiner zu bekommen.
                // if (getUserFromLocalStorage().settings) {
                //     let width = getUserFromLocalStorage().settings['dt_column_width_' + props.id + '_' + item.field];
                //
                //     if (item.style === undefined) {
                //         item.style = {}
                //     }
                //
                //     if (width && item.style.width === undefined) {
                //         item.style.width = width + 'px';
                //     }
                // }
                switch (item.type) {
                    case ColumnObjectType.Number:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { key: item.field + '_' + index, sortable: props.sortable, body: showSkeleton ? skeletonBodyTemplate : item.body ? item.body : (rowData) => textColumn(rowData, item.field, item.onClick), editor: item.editCell ? (options) => numberEditor(options) : null, onCellEditComplete: item.editCell ? (e) => {
                                if (item.editCell) {
                                    item.editCell(e.newValue);
                                }
                            } : undefined })));
                    case ColumnObjectType.Checkbox:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: showSkeleton ? skeletonBodyTemplate : undefined, key: item.field + '_' + index, selectionMode: "multiple" // sortable={props.sortable}
                            , style: { width: '30px' } })));
                    case ColumnObjectType.Dropdown:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: showSkeleton ? skeletonBodyTemplate : item.body ? item.body : (rowData) => textColumn(rowData, item.field, item.onClick), key: item.field + '_' + index, sortable: props.sortable, editor: item.editCell ? (options) => dropdownEditor(options, item.filterDropdownValues) : null })));
                    case ColumnObjectType.Date:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: (rowData) => showSkeleton ? skeletonBodyTemplate : item.body ? item.body(rowData) : dateColumn(rowData, item.field, item.dateFormat), key: item.field + '_' + index, sortable: props.sortable, editor: item.editCell ? (options) => dateEditor(options) : null, onCellEditComplete: item.editCell ? (e) => {
                                if (item.editCell) {
                                    item.editCell(e.newValue);
                                }
                            } : undefined })));
                    case ColumnObjectType.Buttons:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: (rowData) => showSkeleton ? skeletonBodyTemplate : buttonTemplate(rowData, item.options), key: item.field + '_' + index, sortable: props.sortable })));
                    case ColumnObjectType.Image:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: (rowData) => showSkeleton ? skeletonBodyTemplate : imageTemplate(rowData, item.field), key: item.field + '_' + index, sortable: props.sortable })));
                    case ColumnObjectType.Boolean:
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: (rowData) => showSkeleton ? skeletonBodyTemplate : booleanTemplate(rowData, item.field), key: item.field + '_' + index, sortable: props.sortable })));
                    case ColumnObjectType.StatusLights:
                        filterTemplate.showFilterMatchModes = false;
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: (rowData, options) => showSkeleton ? skeletonBodyTemplate : statusLightsTemplate(rowData, item.field, options), key: item.field, sortable: props.sortable, filterElement: statusFilterTemplate })));
                    default: // Text
                        return ((0, react_1.createElement)(column_1.Column, Object.assign({}, item, filterTemplate, { body: showSkeleton ? skeletonBodyTemplate : item.body ? item.body : (rowData) => textColumn(rowData, item.field, item.onClick), key: item.field + '_' + index, sortable: props.sortable, onFilterClear: () => {
                                setColumnFilters((prevState) => (Object.assign(Object.assign({}, prevState), { [item.field]: null })));
                            }, style: item.style ? {
                                width: item.style.width,
                                flex: `1 ${item.style.width} 1 !important`
                            } : undefined, filterElement: item.filterDropdownValues ? (options) => {
                                // console.log('options: ', options)
                                // console.log('filterDropdownValues: ', item.filterDropdownValues)
                                // console.log('filterDropdownField: ', item.filterDropdownField)
                                return filterDropdownTemplate(options, item.filterDropdownValues, item.filterDropdownField);
                            } : item.filterElement ? item.filterElement : null, editor: item.editCell ? (options) => textEditor(options) : null, onCellEditComplete: item.editCell ? (e) => {
                                if (item.editCell) {
                                    item.editCell(e.newRowData);
                                }
                            } : undefined })));
                }
            }),
            props.columns && selectedColumns.length > 0 && props.expandable && isMobile &&
                (0, jsx_runtime_1.jsx)(column_1.Column, { body: showSkeleton ? skeletonBodyTemplate : undefined, columnKey: 'expander', className: "expander-column pt-2 no-hover", expander: allowExpansion, 
                    // style={{width: '30px'}}
                    reorderable: false, resizeable: false })) }));
};
exports.CustomDataTable = CustomDataTable;
